import Immutable from 'immutable'
import { createSelector } from 'reselect'

import { getBasketRecipes } from 'selectors/basket'
import { getAvailableRecipes } from 'selectors/menu-recipes/getAvailableRecipes'
import { getRecipeIdByCoreId } from 'selectors/menu-recipes/getRecipeIdByCoreId'

export const getOkRecipeIds = (state) => {
  const availableRecipes = getAvailableRecipes(state)

  const basketRecipes = getBasketRecipes(state)
  const basketRecipeAmounts = basketRecipes.toJS()
  const basketRecipeDetails = Object.entries(basketRecipeAmounts).map(([coreId, amount]) => ({
    coreId,
    uuid: getRecipeIdByCoreId(coreId)(state),
    amount,
  }))

  return Immutable.fromJS(
    Object.fromEntries(
      basketRecipeDetails
        .filter(({ uuid }) => uuid && uuid in availableRecipes)
        .map(({ coreId, amount }) => [coreId, amount]),
    ),
  )
}

export const getUnavailableRecipeIds = createSelector(
  getBasketRecipes,
  getOkRecipeIds,
  (basketRecipes, okRecipeIds) =>
    basketRecipes.filter((obj, recipeId) => !okRecipeIds.has(recipeId)),
)

export const getBasketRecipesIDs = createSelector(getBasketRecipes, (recipesIDs) =>
  recipesIDs.keySeq().toArray(),
)
